import LoyaltyEarnWidget from './LoyaltyEarnWidget';

export default LoyaltyEarnWidget;
